import { render, staticRenderFns } from "./Classes.vue?vue&type=template&id=4dccb4c6&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Classes.vue"
export default component.exports